var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _vm.$userIsUnverified ? _c("dashboard-verify-email-alert") : _vm._e(),
      _vm._v(" "),
      _vm.$paymentsModuleEnabled
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("h2", { staticClass: "has-button" }, [
              _vm._v("\n      Upcoming Payments\n    "),
            ]),
            _vm._v(" "),
            _vm.haveNoUpcomingPayments
              ? _c("div", { staticClass: "text-center alert alert-default" }, [
                  _vm._v("\n      You have no upcoming payments.\n    "),
                ])
              : _c(
                  "ul",
                  { staticClass: "item-detail list-links item-detail-price" },
                  _vm._l(_vm.payments, function (payment) {
                    return _c("client-dashboard-upcoming-payments-list-item", {
                      key: payment.id,
                      attrs: { payment: payment },
                    })
                  }),
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-info",
                    staticStyle: { "letter-spacing": "2px" },
                    attrs: { to: { name: "payments.index" } },
                  },
                  [_vm._v("View All")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$chatsModuleEnabled && !_vm.haveNoActiveThreads
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("h2", { staticClass: "has-button" }, [
              _vm._v(
                "\n      Active Chats\n      –\n      " +
                  _vm._s(_vm.lists.active_threads_count) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _vm.haveNoActiveThreads
              ? _c("div", { staticClass: "text-center alert alert-default" }, [
                  _vm._v("\n      There are no active chats\n    "),
                ])
              : _c(
                  "ul",
                  { staticClass: "list-items" },
                  _vm._l(_vm.activeThreads, function (thread) {
                    return _c("thread-list-item", {
                      key: thread.id,
                      attrs: { thread: thread, booking: thread.booking },
                    })
                  }),
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-info",
                    staticStyle: { "letter-spacing": "2px" },
                    attrs: { to: { name: "threads.index" } },
                  },
                  [_vm._v("View All")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.haveNoBookingRequests
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("h2", { staticClass: "has-button" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("Booking Requests")) + "\n    "
              ),
            ]),
            _vm._v(" "),
            _vm.haveNoBookingRequests
              ? _c("div", { staticClass: "text-center alert alert-default" }, [
                  _vm._v(
                    "\n      You have no " +
                      _vm._s(_vm.$t("booking requests")) +
                      ".\n    "
                  ),
                ])
              : _c(
                  "ul",
                  { staticClass: "list-items" },
                  _vm._l(_vm.requests, function (booking) {
                    return _c("client-dashboard-booking-requests-list-item", {
                      key: booking.id,
                      attrs: { booking: booking },
                    })
                  }),
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-info",
                    staticStyle: { "letter-spacing": "2px" },
                    attrs: { to: { name: "requests.index" } },
                  },
                  [_vm._v("View All")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.haveNoBookings
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("h2", { staticClass: "has-button" }, [
              _vm._v("\n      Booked Events\n    "),
            ]),
            _vm._v(" "),
            _vm.haveNoBookings
              ? _c("div", { staticClass: "text-center alert alert-default" }, [
                  _vm._v("\n      You have no booked events.\n    "),
                ])
              : _c(
                  "ul",
                  { staticClass: "list-items" },
                  _vm._l(_vm.bookings, function (booking) {
                    return _c("client-dashboard-booking-list-item", {
                      key: booking.id,
                      attrs: { booking: booking },
                    })
                  }),
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-info",
                    staticStyle: { "letter-spacing": "2px" },
                    attrs: { to: { name: "bookings.index" } },
                  },
                  [_vm._v("View All")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }